import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import SectionHeader from "./SectionHeader";

const SKYLINE = "https://images.pexels.com/photos/18441167/pexels-photo-18441167.jpeg";
const FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSczxshX0U9kaMMvExkR26JT4xLyy91m4tQ_BKvNeYGuMRxSmA/viewform?usp=header";

export default function Register() {
  return (
    <section id="register" data-testid="register-section" className="relative py-20 sm:py-24 md:py-32 overflow-hidden">
      {/* Olympus skyline at night */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${SKYLINE})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "brightness(0.28) saturate(0.9)",
        }}
      />
      <div className="absolute inset-0 z-[1] bg-gradient-to-b from-[#0A0A0A] via-black/70 to-[#0A0A0A]" />
      <div className="absolute inset-0 z-[1] bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.15),transparent_60%)]" />

      <div className="relative z-10 max-w-3xl mx-auto px-5 sm:px-6 lg:px-12 text-center">
        <SectionHeader
          eyebrow="Register"
          title={<><span className="text-marble">Claim Your Place </span><span className="italic text-gold-gradient">Among the Titans</span></>}
          subtitle="The gates of Tradella open but once. Inscribe your name and step onto the marble where legacies are forged."
          align="center"
          testId="register-header"
        />

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-12 flex flex-col items-center gap-6"
        >
          <a
            href={FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="register-form-link"
            className="btn-sheen group inline-flex items-center gap-3 px-8 sm:px-10 py-4 sm:py-5 bg-[#B8873B] text-black font-semibold uppercase tracking-[0.3em] text-[11px] sm:text-xs hover:bg-[#E6C88A] transition-colors duration-300"
          >
            Open Registration Form
            <ExternalLink size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
          </a>
          <p className="text-[10px] sm:text-[11px] tracking-[0.3em] uppercase text-white/45">
            Opens Google Forms in a new tab
          </p>
        </motion.div>
      </div>
    </section>
  );
}
